import { useContext } from 'react';
import { ToastContextMobile } from '@teko/ds-foundation';

const useToast = () => {
  return useContext(ToastContextMobile);
};

export { useToast };
